<script lang="ts">
    export let title: string
</script>

<div class="form-control w-full">
    <div class="label">
        <div class="label-text">{title}</div> 
    </div>
    <slot/>
</div>